import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import type { ConnectorType } from 'scaleflow/utils/connectors-config';
import ConnectorIcon from 'scaleflow/components/connectors/icon';
import ArrowLeft from 'scaleflow/components/tailwind-icons/arrow-left';

export interface ConnectorsSuccessPageSignature {
  Args: { connector: ConnectorType };
}

const ConnectorsSuccessPage: TOC<ConnectorsSuccessPageSignature> = <template>
  <div class="flex h-full items-center justify-center">
    <div class="flex flex-col items-center gap-6 text-center">

      <div class="relative">
        <ConnectorIcon @id={{@connector.id}} />
        <span
          class="absolute -top-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-green-500 ring-2 ring-white"
        >
          <svg
            class="h-3.5 w-3.5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="3"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4.5 12.75l6 6 9-13.5"
            />
          </svg>
        </span>
      </div>

      <div>
        <h1 class="text-2xl font-bold text-gray-900">{{t
            "connectors.success.title"
            name=@connector.name
          }}</h1>
        <p class="mt-1 text-sm text-gray-500">{{t
            "connectors.success.message"
          }}</p>
      </div>

      <LinkTo
        @route="connectors"
        class="inline-flex items-center gap-2 rounded-md bg-indigo-500 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <ArrowLeft class="w-4 h-4" />
        Back to
        {{t "dictionary.connectors"}}
      </LinkTo>

    </div>
  </div>
</template>;

export default ConnectorsSuccessPage;
